import { render, staticRenderFns } from "./OtpBackground.vue?vue&type=template&id=2089fd60&"
import script from "./OtpBackground.vue?vue&type=script&lang=js&"
export * from "./OtpBackground.vue?vue&type=script&lang=js&"
import style0 from "./OtpBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports